import React, { useState } from "react";
import {
  LoginResponseType,
  UserDetail,
  UserProfileType,
} from "../../../redux/auth/authTypes";
import ProfilePhoto from "../../Profile/UserDetails/ProfilePhoto";
import BasicDetails from "./BasicDetails/BasicDetails";
import AccessDetails from "./AccessDetails/AccessDetails";
import PersonalDetails from "./PersonalDetails/PersonalDetails";
import Address from "./Address/Address";
import Communications from "./Communications/Communications";
import OnlinePresenc from "./OnlinePresenc/OnlinePresenc";
import { Loader } from "../../commons";
import { DropDownType } from "../../../commonTypes/clientDirectoryTypes";

type PasswordResultType = {
  least: boolean;
  uppercase: boolean;
  special: boolean;
  lower: boolean;
  number: boolean;
};

type AppProps = {
  data: UserDetail;
  isEdit?: boolean;
  profileForm?: UserProfileType;
  setProfileForm?: any;
  handleUserDeatilsForm?: (data: any) => void;
  profileDetailsError?: any;
  setWhatsappCountryCode?: any;
  setMobileCountryCode?: any;
  isEmail?: number | null;
  emailFetching?: boolean;
  emailMessage?: string | null;
  isMobileNo?: number | null;
  mobileFetching?: boolean;
  mobileMessage?: string | null;
  access: boolean;
  handleAccessDeatilsForm: (data: any) => void;
  handlePersonalDetails: (data: any) => void;
  handleAddressDetails: (data: any) => void;
  handlePermanetAddressDetails: (data: any) => void;
  handleCommunicationsDetails: (data: any) => void;

  setNewPassword?: (data: string) => void;
  newPassword?: string;
  finalUserGroupList: any;
  setAssignGroup: (data: string) => void;
  setOffset: (data: any) => void;
  setPasswordResult?: (data: any) => void;
  passwordResult?: PasswordResultType;
  fetchingUser: boolean;
  isNotShow: boolean;
  handleToggleIsAccess: any;
  loginData?: LoginResponseType;
  onlinePresenc: (data: any) => void;
  sameAddress: boolean;
  setSameAddress: any;
  authfetching?: boolean;
  onMenuClose: () => void;
  Option: any;
  countrySelectedList: any;
  countryFetching: boolean;
  setLoadCondition: React.Dispatch<React.SetStateAction<boolean>>;
  setCountryText: React.Dispatch<React.SetStateAction<string>>;
  setCountryOffset: React.Dispatch<React.SetStateAction<number>>;
  countrylimit: number;
  handleChangeCountry: (data: any) => void;
  finalCountry: any;
  handleChangeState: (data: any) => void;
  finalStateList: any;
  stateFetching: boolean;
  setStateText: React.Dispatch<React.SetStateAction<string>>;
  setStateOffset: React.Dispatch<React.SetStateAction<number>>;
  isState: boolean | null;
  isCity: boolean | null;
  addressState: any;
  finalCityList: any;
  selectedCityList: any;
  handleChangeCity: (data: any) => void;
  setCityOffset: React.Dispatch<React.SetStateAction<number>>;
  setCityText: React.Dispatch<React.SetStateAction<string>>;
  finalStateAddressList: any;
  stateFetchingPermanentAddress: boolean;
  setStateAddressText: React.Dispatch<React.SetStateAction<string>>;
  setStateAddressOffset: React.Dispatch<React.SetStateAction<number>>;
  isStatePermanentAddress: boolean | null;
  finalCityAddressList: any;
  cityFetchingPermanentAddress: boolean;
  setCityAddressText: React.Dispatch<React.SetStateAction<string>>;
  setCityAddressOffset: React.Dispatch<React.SetStateAction<number>>;
  isCityPermanentAddress: boolean | null;
  isDisabledEditField?: boolean;
  skillsText?: string;
  finalSkillList?: DropDownType[] | [];
  setSkillsOffset?: React.Dispatch<React.SetStateAction<number>>;
  setSkillsText?: React.Dispatch<React.SetStateAction<string>>;
  handleSkillChange?: (data: any) => void;
  skillFetching?: boolean;
  limit?: number;

};
const AllUserDetails = ({
  data,
  isEdit,
  setProfileForm,
  handleUserDeatilsForm,
  profileForm,
  profileDetailsError,
  setWhatsappCountryCode,
  setMobileCountryCode,
  isEmail,
  emailFetching,
  emailMessage,
  isMobileNo,
  mobileFetching,
  mobileMessage,
  handleAccessDeatilsForm,
  access,
  handleToggleIsAccess,
  setNewPassword,
  newPassword,
  finalUserGroupList,
  passwordResult,
  fetchingUser,
  setAssignGroup,
  setOffset,
  setPasswordResult,
  handlePersonalDetails,
  handleAddressDetails,
  handlePermanetAddressDetails,
  handleCommunicationsDetails,
  onlinePresenc,
  isNotShow,
  sameAddress,
  setSameAddress,
  loginData,
  authfetching,
  onMenuClose,
  Option,
  countrySelectedList,
  countryFetching,
  setLoadCondition,
  setCountryText,
  setCountryOffset,
  countrylimit,
  handleChangeCountry,
  finalCountry,
  handleChangeState,
  finalStateList,
  stateFetching,
  setStateText,
  setStateOffset,
  isState,
  isCity,
  addressState,
  finalCityList,
  selectedCityList,
  handleChangeCity,
  setCityOffset,
  setCityText,
  finalStateAddressList,
  stateFetchingPermanentAddress,
  setStateAddressText,
  setStateAddressOffset,
  isStatePermanentAddress,
  finalCityAddressList,
  cityFetchingPermanentAddress,
  setCityAddressText,
  setCityAddressOffset,
  isCityPermanentAddress,
  isDisabledEditField,
  skillsText,
  finalSkillList,
  setSkillsOffset,
  setSkillsText,
  handleSkillChange,
  skillFetching,
  limit
}: AppProps) => {
  return (
    <>
      <div className="user-profile-form">
        <div className="mb-3">
          <h5 style={{ marginBottom: "20px" }}>User Profile Details</h5>
          <ProfilePhoto
            data={data}
            setProfileForm={setProfileForm}
            isEdit={isEdit ? isEdit : ""}
          />
        </div>
        <div>
          <BasicDetails
            data={data?.basic_details}
            isEdit={isEdit ? isEdit : ""}
            setProfileForm={setProfileForm}
            handleUserDeatilsForm={handleUserDeatilsForm}
            profileDetailsError={profileDetailsError}
            emailFetching={emailFetching}
            isEmail={isEmail}
            emailMessage={emailMessage}
            loginData={loginData}
            isDisabledEditField={isDisabledEditField}
            skillsText={skillsText}
            finalSkillList={finalSkillList}
            setSkillsOffset={setSkillsOffset}
            setSkillsText={setSkillsText}
            handleSkillChange={handleSkillChange}
            skillFetching={skillFetching}
            limit={limit}
          />
        </div>
      </div>
      <AccessDetails
        setProfileForm={setProfileForm}
        data={data?.basic_details}
        isEdit
        handleAccessDeatilsForm={handleAccessDeatilsForm}
        handleToggleIsAccess={handleToggleIsAccess}
        access={access}
        profileDetailsError={profileDetailsError}
        setNewPassword={setNewPassword}
        newPassword={newPassword}
        finalUserGroupList={finalUserGroupList}
        setAssignGroup={setAssignGroup}
        setOffset={setOffset}
        passwordResult={passwordResult}
        setPasswordResult={setPasswordResult}
        fetchingUser={fetchingUser}
        isNotShow={isNotShow}
        loginData={loginData}
        isDisabledEditField={isDisabledEditField}
      />
      <PersonalDetails
        data={data?.personal_details}
        isEdit
        setProfileForm={setProfileForm}
        handlePersonalDetails={handlePersonalDetails}
      />
      <Address
        data={data?.current_address}
        permanentAddressData={data?.permanent_address}
        isEdit
        setProfileForm={setProfileForm}
        handleAddressDetails={handleAddressDetails}
        handlePermanetAddressDetails={handlePermanetAddressDetails}
        sameAddress={sameAddress}
        setSameAddress={setSameAddress}
        onMenuClose={onMenuClose}
        Option={Option}
        countrySelectedList={countrySelectedList}
        countryFetching={countryFetching}
        setLoadCondition={setLoadCondition}
        setCountryText={setCountryText}
        setCountryOffset={setCountryOffset}
        countrylimit={countrylimit}
        finalCountry={finalCountry}
        handleChangeCountry={handleChangeCountry}
        handleChangeState={handleChangeState}
        finalStateList={finalStateList}
        stateFetching={stateFetching}
        setStateText={setStateText}
        setStateOffset={setStateOffset}
        isState={isState}
        isCity={isCity}
        addressState={addressState}
        finalCityList={finalCityList}
        selectedCityList={selectedCityList}
        handleChangeCity={handleChangeCity}
        setCityOffset={setCityOffset}
        setCityText={setCityText}
        finalStateAddressList={finalStateAddressList}
        stateFetchingPermanentAddress={stateFetchingPermanentAddress}
        setStateAddressText={setStateAddressText}
        setStateAddressOffset={setStateAddressOffset}
        isStatePermanentAddress={isStatePermanentAddress}
        finalCityAddressList={finalCityAddressList}
        cityFetchingPermanentAddress={cityFetchingPermanentAddress}
        setCityAddressText={setCityAddressText}
        setCityAddressOffset={setCityAddressOffset}
        isCityPermanentAddress={isCityPermanentAddress}
        profileDetailsError={profileDetailsError}
      />
      <Communications
        data={data?.contact_details}
        isEdit
        setProfileForm={setProfileForm}
        isMobileNo={isMobileNo}
        mobileFetching={mobileFetching}
        mobileMessage={mobileMessage}
        handleCommunicationsDetails={handleCommunicationsDetails}
      />
      <OnlinePresenc
        onlinePresenc={onlinePresenc}
        isEdit
        data={data?.online_presence}
      />
      {authfetching && <Loader />}
    </>
  );
};

export default AllUserDetails;
